import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Global } from '@emotion/react';
import { BridgePage } from '@src/pages/bridge';
import { DownloadPage } from '@src/pages/download';
import { globalStyle } from '@src/global-style';
import { TestPage } from './pages/test';

const router = createBrowserRouter([
  { path: '/', element: <BridgePage /> },
  { path: '/bridge', element: <BridgePage /> },
  { path: '/download', element: <DownloadPage /> },
  { path: '/test', element: <TestPage /> },
]);

export const App = () => {
  return (
    <>
      <Global styles={globalStyle} />
      <RouterProvider router={router} />
    </>
  );
};
